import { toast } from '@/shared/toast'
import { useSetFieldValue } from '@/shared/useSetFieldValue'
import { invariant } from '@/shared/utils/typeAssertions'
import { useWorkspaces } from '../Workspaces/useWorkspaces'
import type { Field } from './Fields/types'
import { useProject } from './useProject'

export const useFieldReset = () => {
  const projectStore = useProject()
  const setFieldValue = useSetFieldValue()
  const workspacesStore = useWorkspaces()

  const resetField = async (field: Field) => {
    const projectId = projectStore.projectId
    const workspaceId = workspacesStore.currentWorkspace?.id

    invariant(workspaceId && projectId, 'Current workspace and project ID are required')

    const res = await setFieldValue({
      workspaceId,
      projectId,
      fields: { [field.propertyId]: { field, newValue: null } },
      entityId: field.entityId,
    })

    if (!res.ok) {
      toast.error('Failed to save value, please try again.')
    }
  }

  return { resetField }
}
